/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Card} from 'antd';
import moment from 'moment';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config, toFixed2} from 'Utils';
import {
    discountDetail, discountType, discountDetailExportExcel, threeHead,
    dmsPurchaseList
} from '../../service/reportForm';
import {fetchChannelList} from "../../service/home";

class DiscountPoolInquiries extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['折扣池明细查询'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            rowheader: [],
            total: 0,
            dateMapTotal: 0,
            searchObj: {
                salesChannelCode: '',
                s: 10,
                p: 1,
                transactionDateBegin: moment().format('YYYY-MM-DD'),
                transactionDateEnd: moment().format('YYYY-MM-DD'),
                middle: '',
                balanceStart: '',
                balanceEnd: '',
                salesUnitId: '',
            },
            middleOptions: [],
            salesUnitOptions: [],
            three: {},
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        let totalAmount = 0;
        if (selectedRows.length > 0) {
            selectedRows.forEach(item => {
                totalAmount += item.amount ? item.amount : 0;
            });
        }
        this.setState({selectedRowKeys, dateMapTotal: totalAmount});
    };

    goView(url) {
        hashHistory.push(url);
    }

    goAdd() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/discountDetail/exportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                salesChannelCode: this.channelId,
                s: 10,
                p: 1,
                transactionDateBegin: '',
                transactionDateEnd: '',
                salesUnitId: '',
                middle: '',
                balanceStart: '',
                balanceEnd: '',
            }, loading: false
        }, function () {
            //self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.transactionDateBegin || this.state.searchObj.transactionDateBegin == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.transactionDateEnd || this.state.searchObj.transactionDateEnd == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    transactionDateBegin: value.from,
                    transactionDateEnd: value.end
                }
            })
        } else {
            if (value == 'ALL') {
                this.setState({searchObj: {...this.state.searchObj, [name]: ''}})
            } else {
                this.setState({searchObj: {...this.state.searchObj, [name]: value}})
            }
        }
    };

    pageChange(page) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        discountDetail(searchObj).then(function (result) {
            if (result && result.code == 200) {
                const data = result.data || [];
                let totalAmount = 0;
                data.forEach(item => {
                    totalAmount += item.amount ? item.amount : 0;
                });
                self.setState({
                    rows: data,
                    total: result.total || 0,
                    dateMapTotal: totalAmount,
                    loading: false
                });
            } else {
                openNotice('warning', '数据获取失败', '');
                this.setState({loading: false});
            }
        });
        threeHead(searchObj).then(res => {
            if (res.data && res.status == true) {
                self.setState({
                    three: res.data.data,
                    rowheader: res.data.data2
                })
            } else {
                openNotice('warning', '数据获取失败')
            }
        })
    }

    componentWillMount() {
        discountType({}).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.middleDesc,
                        value: x.middleDesc
                    })
                });
                this.setState({middleOptions: arr})
            }

        });
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                this.setState({channel_type: arr},
                )
            }
        });
        dmsPurchaseList({channelCode: window.sessionStorage.getItem('cur_channelId'), s: 999}).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({salesUnitOptions: arr})
            }
        });
    }

    componentDidMount() {
        // this.initData();
    }

    render() {
        const {opts, key, rows, total, searchObj, selectedRowKeys, salesUnitOptions, middleOptions, dateMapTotal, loading, rowheader, channel_type} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'date',//transactionDateBegin, transactionDateEnd
                    label: '查询期间',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.transactionDateBegin || '',
                        end: searchObj.transactionDateEnd || ''
                    }
                }, {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '选择购货单位',
                    options: salesUnitOptions,
                    multiple: false,
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'middle',
                    label: '折扣中类',
                    text: '选择折扣中类',
                    options: middleOptions,
                    defaultValue: searchObj.middle,
                    multiple: false,//支持多选
                    width: 100,
                    type: 'select'
                },
                {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: false,
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '折扣大类',
                    dataIndex: 'main',
                }, {
                    title: '折扣中类',
                    dataIndex: 'middle',
                }, {
                    title: '折扣明细类',
                    dataIndex: 'detail',
                }, {
                    title: '事物处理日期',
                    dataIndex: 'transactionDate',
                }, {
                    title: '单据编号',
                    dataIndex: 'transferNumber'
                }, {
                    title: '出库单号',
                    dataIndex: 'deliveryNumber',
                }, {
                    title: '金额',
                    dataIndex: 'amount',
                }, {
                    title: '行说明',
                    dataIndex: 'description',
                }
            ],
            rows
        };
        const tableViewProps2 = {
            loading: loading,//更新表格数据中
            rowKey: 'RN',
            pageParam: {
                total: 1,
                current: 1,//当前页码
                pageSize: 10,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '期初余额',
                    dataIndex: 'INITAMOUNT',
                }, {
                    title: '录入',
                    dataIndex: 'LRAMOUNT',
                }, {
                    title: '支付',
                    dataIndex: 'ZFAMOUNT',
                }, {
                    title: '冲应收',
                    dataIndex: 'CYSAMOUNT',
                }, {
                    title: '发票折扣',
                    dataIndex: 'FPAMOUNT',
                }, {
                    title: '现金支付',
                    dataIndex: 'XJAMOUNT'
                }, {
                    title: '银行支付',
                    dataIndex: 'YHAMOUNT',
                }, {
                    title: '扣税金',
                    dataIndex: 'KSJAMOUNT',
                }, {
                    title: '代扣代付',
                    dataIndex: 'DKDFAMOUNT',
                }, {
                    title: '核销',
                    dataIndex: 'HXAMOUNT',
                }, {
                    title: '渠道调整',
                    dataIndex: 'QDTZAMOUNT',
                }, {
                    title: '收回',
                    dataIndex: 'SHAMOUNT',
                }, {
                    title: '期末余额',
                    dataIndex: 'ENDAMOUNT',
                }
            ],
            rows: rowheader
        };

        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="dms-table-box">
                    <div className="invoice_detail">
                        <div className="infor">
                            <Card title="折扣池剩余总额" noHovering>
                                <Card.Grid style={{
                                    width: '25%',
                                    textAlign: 'center'
                                }}>折扣池余额:{this.state.three.DISCOUNTAMOUNT || '0'}</Card.Grid>
                                <Card.Grid style={{
                                    width: '25%',
                                    textAlign: 'center'
                                }}>销售折扣折让余额:{this.state.three.SALESAMOUNT || '0'}</Card.Grid>
                                <Card.Grid style={{
                                    width: '25%',
                                    textAlign: 'center'
                                }}>已发运未登记折扣余额:{this.state.three.RETAINAMOUNT || '0'}</Card.Grid>
                                <Card.Grid style={{
                                    width: '25%',
                                    textAlign: 'center'
                                }}>销售折扣折让开单可折余额:{this.state.three.KDAMOUNT || '0'}</Card.Grid>
                            </Card>
                        </div>
                    </div>
                </div>
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goAdd.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps2} />
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}

export default withRouter(DiscountPoolInquiries);


// WEBPACK FOOTER //
// ./src/routes/reportForm/discountPoolInquiries.js